var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
export {
  WHITE_SPACE_REGEX
};
//# sourceMappingURL=regex.generated.js.map
